
export const getMongoOperator=(type)=>{

    //add here custom operators

    return `$${type.toLowerCase()}`; //AND => $AND | OR=> $OR;
}